import { render } from "./Week.vue?vue&type=template&id=b271a01e&scoped=true"
import script from "./Week.vue?vue&type=script&lang=js"
export * from "./Week.vue?vue&type=script&lang=js"

import "./Week.vue?vue&type=style&index=0&id=b271a01e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b271a01e"]])

export default __exports__